import { useState, useCallback } from "react";

export const useDarkMode = () => {
  const [isDark, setIsDark] = useState(true);
  const toggle = useCallback(() => setIsDark((prev) => !prev), []);
  return { isDark, toggle };
};